import {
    FETCH_COUPONS,
    FETCH_COUPON,
    FETCH_COUPON_BY_CODE,
    CREATE_COUPON,
    UPDATE_COUPON,
    DELETE_COUPON,
    COUPON_ERROR,
    START_LOADING,
    END_LOADING,
} from "../actions/constants";

const initialState = { isLoading: false, coupons: [], couponById: null, couponByCode: null, error: null, numberOfPages: 0 }

const coupons = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true, error: null };
        case END_LOADING:
            return { ...state, isLoading: false };
        case FETCH_COUPONS:
            return {
                ...state,
                coupons: action.payload.data,
                numberOfPages: action.payload.numberOfPages,
                error: null,
            };
        case FETCH_COUPON:
            return { ...state, couponById: action.payload.data, error: null };
        case FETCH_COUPON_BY_CODE:
            return { ...state, couponByCode: action.payload.data, error: null };
        case CREATE_COUPON:
            return {
                ...state,
                coupons: [...state.coupons, action.payload.data],
                error: null
            };
        case UPDATE_COUPON:
            return {
                ...state,
                coupons: state.coupons.map((coupon) =>
                    coupon._id === action.payload._id ? action.payload : coupon
                ),
                error: null
            };
        case DELETE_COUPON:
            return {
                ...state,
                coupons: state.coupons.filter(
                    (coupon) => coupon._id !== action.payload
                ),
                error: null
            };
        case COUPON_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default coupons;

